import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Base64} from 'js-base64';
import { Person } from '../../@core/data/person';
import { JurPerson } from '../../@core/data/jur-person';
import { SmartTableData } from '../../@core/data/smart-table';
import { RestService } from '../../@core/utils/rest.service';
import { bank } from '../../@core/data/bank';
import { TypedJSON } from 'typedjson'
import { NgModule } from '@angular/core';
import { SourceMapGenerator } from '@angular/compiler/src/output/source_map';
import { Ng2SmartTableModule, LocalDataSource } from 'ng2-smart-table';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDatepickerInputEvent, MatTableDataSource } from '@angular/material';
import { formatDate } from '@angular/common';
import {MatTableModule} from '@angular/material/table';
import Swal from 'sweetalert2';
import { DomSanitizer } from '@angular/platform-browser';
import {MatSort} from '@angular/material/sort';
import {Sort} from '@angular/material/sort';
import { PaymentComponent } from '../payment/payment.component';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Result } from '../../@core/data/result';
// import { pdfMake } from 'pdfmake/build/vfs_fonts';
declare var pdfMake: any;

@Component({
  selector: 'ngx-paystories',
  templateUrl: './paystories.component.html',
  styleUrls: ['./paystories.component.scss']
})
export class PaystoriesComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;
  private fieldArray: Array<any> = [];
  private newAttribute: any;
  displayedColumns: string[] = ['DATEPAY', 'beneficiar', 'sumpay', 'typepay','assign']; 
  data2:any;
  payments: any[];
  bin: string;
  data1: any;
  paymentDetail: any;
  dateStartOrder: any;
  dateEndOrder: any;
  todayOrder: any;

  indexEconome: number;
  reciver: any[];
  title: string;
  dataA: any;
  todayOrder7: any;
  maxStart:any;
  minEnd:any;
  today=new Date();
  dataSource: MatTableDataSource<unknown>;
  sortedData: any[];
  textVis:boolean=false;
  tableVis:boolean=true;
  objectLang: any;
  token: any;
  jurPerson: any;
  constructor(
    private fb: FormBuilder,
    private toastrService: NbToastrService, 
    public rest:RestService,
    private sanitizer: DomSanitizer,
    private dialogService: NbDialogService,
    private service: SmartTableData,
    public translate: TranslateService ,
    private router: Router,
    ) 
    {
      // this.sortedData = this.payments.slice();

    }

    sortData(sort: Sort) {
      const data = this.payments.slice();
      if (!sort.active || sort.direction === '') {
        this.sortedData = data;
        return;
      }
  
      this.sortedData = data.sort((a, b) => {
        const isAsc = sort.direction === 'asc';
        switch (sort.active) {
          case 'DATEPAY': return compare(a.DATEPAY, b.DATEPAY, isAsc);
          case 'beneficiar': return compare(a.beneficiar, b.beneficiar, isAsc);
          case 'sumpay': return compare(a.sumpay, b.sumpay, isAsc);
          case 'typepay': return compare(a.typepay, b.typepay, isAsc);
          // case 'protein': return compare(a.protein, b.protein, isAsc);
          default: return 0;
        }
      });
    }
    open(dialog: TemplateRef<any>) {
      this.dialogService.open(dialog, { context: 'this is some additional data passed to dialog' });
    }

    getDetail(id_pay:any,dialog:any){
     try{
      console.log(id_pay);
      if (id_pay!=undefined){
      this.rest.getPaymentDetails(id_pay).subscribe((data: any) => 
      {
        if (data.code=='0'){
      this.paymentDetail=data.message[0].IDN;
      console.log(JSON.parse(data.message));
      console.log(data)
      var bodyData = [];
      var sourceData = JSON.parse(data.message);
      var dataRow1= [];
      let n=1;
      
      sourceData.forEach(function(sourceRow) {
        var dataRow = [];

        number: dataRow.push(n);
        ID:dataRow.push(sourceRow.IDN);
        Name:dataRow.push(sourceRow.FM);
        LastName:dataRow.push(sourceRow.NM);
        Surname:dataRow.push(sourceRow.FT);
        BB:dataRow.push(sourceRow.BIRTHDATE);
        Period:dataRow.push(sourceRow.PERIOD_PAY);
        SUM:dataRow.push(sourceRow.SUMPAY);
        
        bodyData.push(dataRow);
        n++;
      });
      ID:dataRow1.push('№');
      Name:dataRow1.push('ИИН');
      Surname:dataRow1.push('Фамилия');
      LastName:dataRow1.push('Имя');
      LastName:dataRow1.push('Отчество');
      LastName:dataRow1.push('Дата рождения');
      LastName:dataRow1.push('Период Платаежа');
      LastName:dataRow1.push('Cумма');
      //dataRow.unshift('№','ИИН','Фамилия','Имя','Отчество','Дата рождения','Период Платаежа','Сумма');
      bodyData.unshift(dataRow1);
    
      
      for(let i=0; i<this.payments.length;i++){
       if (this.payments[i].ID_PAY==id_pay){
           console.log(this.payments[i].ID_PAY+'---' +this.payments[i].typepay);
           if (this.payments[i].typepay=='10' ||this.payments[i].typepay =='15' || this.payments[i].typepay=='19'|| this.payments[i].typepay=='11' ){
              this.indexEconome = 0;
               }
           if (this.payments[i].typepay=='13') {
                this.indexEconome = 1;
              }
          console.log(this.indexEconome);

        var dd = {
        // pageSize: 'A4',
        pageOrientation: 'portrait',
        content: [
          {text: 'Платежное поручения № ' +this.payments[i].NUM, style: 'header',alignment: 'center'},
            {text: 'Дата: ' + this.payments[i].DATEPAY, fontSize: 10, margin: [0, 10, 0, 2] },
          {
            style:  {
              header: {
                fontSize: 25,
                bold: true,
                alignment: 'center',
              },
              headerRow: {
                bold: true,
                alignment: 'center',
              },
              subheader: {
                fontSize: 16,
                bold: true,
                margin: [0, 10, 0, 5]
              },
              tableExample: {
                margin: [0, 5, 0, 15],
                fontSize: 10,
                color: 'black'
              },
              tableHeader: {
                bold: true,
                fontSize: 13,
                color: 'black'
              },
              textTable: {
                fontSize: 10,
                color: 'black'
              }}
        ,
            table: {
                widths: [220, 150, 30, 100],
                
              body: [
      
        /*1 row*/	   [ 
                      
                            [{colSpan:1,text:[{text: 'Отправитель денег: '},{text:sessionStorage.getItem("nameJur"), bold:true, }]},{colSpan:1,text:[{text: '\nБИН: '}, {text:this.payments[i].bin,bold:true}]}],
                        [{text: 'ИИК', alignment: 'center', }, {text:'\n'+ this.payments[i].iban, alignment: 'center',bold:true }], 
                      [{text: 'КОД', alignment: 'center'}, {text:'\n'+sessionStorage.getItem("KBE"), alignment: 'center',bold:true }],
                        {rowSpan:5,text:[{text: 'СУММА\n\n\n\n\n\n\n\n', alignment: 'center'},{text:this.payments[i].sumpay, alignment:'center',bold:true}]}
                     ],
        
        /*2 row*/	   [ 
                            {colSpan:1,text:[{text: 'Банк-получатель: '}, {text:this.payments[i].bank,bold:true}]},
                            {colSpan:2,text:[{ text: 'БИК\n\n', alignment: 'center'}, {text:this.payments[i].mfo, alignment: 'center',bold:true}]}, 
                            '',
                            ''
                       ],
                         
        /*3 row*/      [ 
                            [{colspan:1,text:[{text: 'Бенефициар: '},{text:this.payments[i].beneficiar, bold:true}]}, {colSpan:1,text:[{text:'\nБИН: '},{text:this.reciver[this.indexEconome].bin, bold:true}]}],
                            [{text: 'ИИК\n\n\n', alignment: 'center'},{text:this.reciver[this.indexEconome].account, bold:true, alignment: 'center'}], 
                            [{text: 'КБЕ\n\n\n', alignment: 'center'}, {text:this.reciver[this.indexEconome].kBe, alignment: 'center' }],
                            ''
                        ],
                        
        /*4 row*/        [
                              {colSpan:1,text:[{text:'Банк бенефициара: '},{text:this.reciver[this.indexEconome].bank, bold:true}]},
                            {colSpan: 2,text:[{text:'БИК',alignment:'center'},{text:'\n\n'+this.reciver[this.indexEconome].bik, bold:true, alignment:'center'}]},
                            '',
                            ''
                       ],
                       
        /*5 row*/  	    [
                              {colSpan:3,text:[{text:'Сумма прописью: '},{text:this.number_to_string(parseFloat(this.payments[i].sumpay)),bold:true}]},
                            '',
                            '',
                            ''
                        ],
                        
        /*6 row*/  	    [
                              {rowSpan:2,text:''},
                            {colSpan:2,text:'Код назначения платежа',alignment:'center'},
                            '',
                            {text:this.payments[i].typepay,alignment:'center',bold:true}
                        ],
                        
        /*7 row*/         [
                              '',
                            {colSpan:2,text:'Код бюджетной классификации',alignment:'center', margin:[0,5]},
                            '',
                            {text:'',alignment:'center',bold:true,margin:[0,5]}
                        ],
                        
      /*8 row*/ 	        [
                             [ {text:'Назначение платежа:'},{text:this.payments[i].assign,bold:true}],
                            {colSpan:2,text:'Дата валютирования',alignment:'center', margin:[0,25]},
                            '',
                            {text:this.payments[i].DATEVAL,alignment:'center',bold:true, margin:[0,25]}
                        ]
              ]
            }
              
          },
          {text: 'Руководитель', fontSize: 10, margin: [0, 40, 0, 2] },
          {text: 'Проведено банком-получателем', fontSize: 10, margin: [320, -14, 0, 2] },
          {text: 'м.п.', fontSize: 10, margin: [0, 10, 0, 2] },
  
  
          {
          pageBreak: 'before', 
          pageOrientation: 'landscape' ,
          text: 'Список на пречисление обязательных пенсионных взносов', style: 'header',alignment: 'center',margin:[0,10]},
          {text: 'К платежному поручению № ' +  this.payments[i].NUM + ' от ' + this.payments[i].DATEPAY , fontSize: 10, margin: [0, 10, 0, 2] },
          {text:  ''+sessionStorage.getItem("nameJur") , fontSize: 10, margin: [0, 4, 0, 2] },
          {text:  'БИН: '+this.payments[i].bin, fontSize: 10, margin: [0, 4, 0, 2] },
          {text:  'КОД: '+sessionStorage.getItem("KBE") , fontSize: 10, margin: [0, 4, 0, 2] },
          {text:  'ИИК: '+this.payments[i].iban, fontSize: 10, margin: [0, 4, 0, 2] },
          
              {
              style: 'tableExample', margin:[0,8],fontSize: 10,
            table: {
              headerRows: 1,style: 'headerRow',
                widths: [15,70, '*', '*','*',60,60,'*'],
            
               
                  
                    // [
                    // {text:  '№, п/п', fontSize: 10, margin: [0, 4, 0, 2] },
                    // {text:  'ИИН', fontSize: 10,  alignment: 'center', margin: [0, 8] },
                    // {text:  'Фамилия', fontSize: 10, alignment: 'center', margin: [0, 8] },
                    // {text:  'Имя', fontSize: 10, alignment: 'center', margin: [0, 8] },
                    // {text:  'Отчество', fontSize: 10, alignment: 'center', margin: [0, 8]},
                    // {text:  'Дата рождения', fontSize: 10, alignment: 'center', margin: [0, 8]},
                    // {text:  'Период платежа', fontSize: 10, alignment: 'center', margin: [0, 8]},
                    // {text:  'Сумма', fontSize: 10, alignment: 'center', margin: [0, 8]}
                    
                    // ],  
                
              body:bodyData,
                
                    }},
        ]
      
      };
      const pdfDocGenerator = pdfMake.createPdf(dd);
      pdfDocGenerator.getBase64((data1) => {
      console.log(typeof(data1));
         console.log(this.dataA="data:application/pdf;base64,"+data1);
        //  let myDiv = document.getElementById('my-div');
        //  myDiv.setAttribute("src", this.dataA); // adds a src attribute (with the value myPath) to myImg
      //  document.getElementById("myFrame").src = this.dataA;
      //  document.getElementById('myFrame').setAttribute("src", this.dataA);
      //  $("#myFrame").attr("src", "www.google.com");
      this.dataA=this.sanitizer.bypassSecurityTrustResourceUrl(this.dataA)
      sessionStorage.setItem('PDF',this.dataA);
    
      // let iframe = this.hostElement.nativeElement.querySelector('iframe');
      // iframe.src = this.dataA;
      this.open(dialog);
       });
      }
     }}
     if (data.code=='-1'){
      Swal.fire({
        text: this.objectLang.ALERTNOSERVICE,
        type: 'error',
        confirmButtonText: 'OK'
      })
     }

    });
   } 
    else {
      Swal.fire({
        text: this.objectLang.ALERTNOSERVICE,
        type: 'error',
        confirmButtonText: 'OK'
      })
    }
  }
  catch(e){
    Swal.fire({
      text:  this.objectLang.ALERTNOSERVICE,
      type: 'error',
      confirmButtonText: 'OK'
    })
  }
    }

     //Получение данные получателя 
  
  loadOrder(){
    try{

      if (this.dateStartOrder && this.dateEndOrder){
        this.rest.getPayments(JSON.parse(sessionStorage.getItem('jurPerson')).bin,this.dateStartOrder,this.dateEndOrder, (this.token==undefined? '': this.token),'0').subscribe((data: string) => {
        console.log(data)  
        this.payments = JSON.parse(JSON.parse(JSON.stringify(data)).message);
        console.log(this.payments);
        if (this.payments.length==0){
          // Swal.fire({
          //   text: this.objectLang.ALERTNONOTEPERIOD,
          //   type: 'info',
          //   confirmButtonText: 'OK'
          // })
          this.tableVis=false;
          this.textVis=true;
          return;
          
        }
        if (this.payments.length!=0){
          this.sortedData = this.payments.slice();
          this.textVis=false;
          this.tableVis=true;
        }
        if(JSON.parse(JSON.stringify(data)).code=="-1"){
          Swal.fire({
            text: this.objectLang.ALERTUNCORRECTDATE,
            type: 'error',
            confirmButtonText: 'OK'
          })
        }
      });
    }
      if (!this.dateStartOrder && this.dateEndOrder){
          this.rest.getPayments(JSON.parse(sessionStorage.getItem('jurPerson')).bin,this.deltaDate(0,-1,0),this.dateEndOrder, (this.token==undefined? '': this.token),'0').subscribe((data: string) => {
            this.payments = JSON.parse(JSON.parse(JSON.stringify(data)).message);
            if (this.payments.length!=0){
              this.sortedData = this.payments.slice();
              this.textVis=false;
              this.tableVis=true;
            }
            if (this.payments.length==0){
              // Swal.fire({
              //   text: this.objectLang.ALERTNONOTEPERIOD,
              //   type: 'info',
              //   confirmButtonText: 'OK'
              // })
              this.tableVis=false;
              this.textVis=true;
              return;
            }
            if(JSON.parse(JSON.stringify(data)).code=="-1"){
              Swal.fire({
                text: this.objectLang.ALERTUNCORRECTDATE,
                type: 'error',
                confirmButtonText: 'OK'
              })
            }
          });
   
      }
      if (this.dateStartOrder && !this.dateEndOrder){
        this.rest.getPayments(JSON.parse(sessionStorage.getItem('jurPerson')).bin,this.dateStartOrder,this.deltaDate(0,-1,0), (this.token==undefined? '': this.token),'0').subscribe((data: string) => {
        this.payments = JSON.parse(JSON.parse(JSON.stringify(data)).message);
        if (this.payments.length!=0){
          this.sortedData = this.payments.slice();
          this.textVis=false;
          this.tableVis=true;
        }
        if (this.payments.length==0){
          Swal.fire({
            text: this.objectLang.ALERTNONOTEPERIOD,
            type: 'info',
            confirmButtonText: 'OK'
          })
          this.tableVis=false;
          this.textVis=true;
        }
        if(JSON.parse(JSON.stringify(data)).code=="-1"){
          Swal.fire({
            text: this.objectLang.ALERTUNCORRECTDATE,
            type: 'error',
            confirmButtonText: 'OK'
          })
        }
      });
   
      }
      if (!this.dateStartOrder && !this.dateEndOrder){
        this.rest.getPayments(JSON.parse(sessionStorage.getItem('jurPerson')).bin,this.deltaDate(0,-1,0),this.deltaDate(0,0,0), (this.token==undefined? '': this.token),'0').subscribe((data: string) => {
        this.payments = JSON.parse(JSON.parse(JSON.stringify(data)).message);
        if (this.payments.length!=0){
          this.sortedData = this.payments.slice();
          this.textVis=false;
          this.tableVis=true;
        }
        if (this.payments.length==0){
          // Swal.fire({
          //   text: this.objectLang.ALERTNONOTEPERIOD,
          //   type: 'info',
          //   confirmButtonText: 'OK'
          // })
          this.tableVis=false;
          this.textVis=true;
          return;
        }
        if(JSON.parse(JSON.stringify(data)).code=="-1"){
          Swal.fire({
            text: this.objectLang.ALERTUNCORRECTDATE,
            type: 'error',
            confirmButtonText: 'OK'
          })
        }
      });
   
      }

      
    }
    catch(e){
      Swal.fire({
        text: this.objectLang.ALERTTECHNICAL,
        type: 'error',
        confirmButtonText: 'OK'
      })
    }
  }
  
  ngOnInit() {
 
    this.maxStart=new FormControl (new Date());  
    this.minEnd=new FormControl (new Date(this.deltaDate2(0,-1,0)));     
    this.todayOrder=new FormControl (new Date());
    this.todayOrder7=new FormControl (new Date(this.deltaDate2(0,-1,0)));
    // this.data2=JSON.parse(sessionStorage.getItem("Payment"));
    // console.log('dat2 is  ' + this.todayOrder7+ '  --  '+this.todayOrder);
    // // console.log(this.data2);
    // this.fieldArray[0]=this.data2;

    // console.log(this.fieldArray);
   // this.today=this.deltaDate(0,0,0);
    try

    {
      this.translate.get(['IIN', 'LASTNAME', 'FIRSTNAME','MIDDLENAME','BIRTHDAY','PERIODPAY','STARTDAY','ENDDAY','NOINFO','ALERTIINEMP','ALERTERR','ALERTFILLNAME','ALERTFILLLASTNAME','ALERTFILLBDATE','ALERTNCHANGESAVED','ALERTEMPTYSAVE','ALERTTECHNICAL']).subscribe(translations => {
        this.objectLang=translations;});
        if (!sessionStorage.getItem('jurPerson')){
          Swal.fire({
            text: this.objectLang.ALERTTECHNICAL,
            type: 'error',
            confirmButtonText: 'OK',
            confirmButtonColor: "#008e54"
          })  
          this.router.navigate(['/auth/login']);  
         }
         else{
          this.rest.getJurPerson(sessionStorage.getItem('jurPerson')).subscribe((data: Result) => {                
            if (data.code == '0') {
              try
                { 
                  sessionStorage.setItem('errorMessage', '');
                  this.token=JSON.parse(sessionStorage.getItem('jurPerson')).token;
                  let base64 = data.message.toString();
                  let jsonString = Base64.decode(base64); 
                  this.jurPerson = JSON.parse(jsonString);
    
              }
              catch(e)
              {
                  sessionStorage.setItem('errorMessage', e.message);
                  sessionStorage.setItem('jurPerson', '');
                  console.error('error - 1 - ' + e.message);        
                  Swal.fire({
                    text: this.objectLang.ALERTTECHNICAL,
                    type: 'error',
                    confirmButtonText: 'OK',
                    confirmButtonColor: "#008e54"
                  })                  
              }
        }
        if(data.code == '-4'){
          Swal.fire({
            text: data.message,
            type: 'warning',
            confirmButtonText: 'OK',
            confirmButtonColor: "#008e54"
          })  
          sessionStorage.setItem('jurPerson','');
          sessionStorage.setItem('jurName','');
          
          this.router.navigate(['/auth']);    
        }        
        if(data.code == '-1'){
          sessionStorage.setItem('errorMessage', data.message);
          sessionStorage.setItem('jurPerson', '');
          sessionStorage.setItem('jurName','');
          console.error('error - 2 - ' + data.message);   
          Swal.fire({
            text: this.objectLang.ALERTTECHNICAL,
            type: 'error',
            confirmButtonText: 'OK',
            confirmButtonColor: "#008e54"
              })                             
            }          
          });
        }




      this.rest.getRecieverData().subscribe((data: any) => 
      {
        this.reciver  = [];
        this.reciver =JSON.parse(JSON.parse(JSON.stringify(data)).message);
        // console.log( 'reciver '+this.reciver);
      });
          this.token=JSON.parse(sessionStorage.getItem('jurPerson')).token;
          this.rest.getPayments(JSON.parse(sessionStorage.getItem('jurPerson')).bin,formatDate( this.todayOrder7.value, 'dd.MM.yyyy', 'en-US'),formatDate(this.todayOrder.value, 'dd.MM.yyyy', 'en-US'), (this.token==undefined? '': this.token),'0').subscribe((data: string) => {
          this.payments = JSON.parse(JSON.parse(JSON.stringify(data)).message)
            this.sortedData = this.payments.slice();
       
    } );
    // this.translate.get(['ALERTNOSERVICE', 'ALERTNONOTEPERIOD', 'ALERTUNCORRECTDATE']).subscribe(translations => {
    //   this.objectLang=translations;});
    //console.log(this.payments.message);
    }
    catch(e) 
    {
      console.log('Servis are not working call me right now')
      console.error(e.message);
    }

 
//  addFieldValue() {
//         this.fieldArray.push(this.newAttribute)
//         this.newAttribute = {};
//     }

//     deleteFieldValue(index) {
//         this.fieldArray.splice(index, 1);
//     }
}
addDateStartOrder(event: MatDatepickerInputEvent<Date>) {
  this.dateStartOrder =formatDate(event.value, 'dd.MM.yyyy', 'en-US');
  this.minEnd=new FormControl (new Date(this.dateStartOrder));

}
addDateEndOrder(event: MatDatepickerInputEvent<Date>) {
  this.dateEndOrder =formatDate(event.value, 'dd.MM.yyyy', 'en-US');
  this.maxStart=new FormControl (new Date(  this.dateEndOrder));
}
deltaDate(days:number, months:number, years:number) {
  var date = new Date();
  let isToday = (date.valueOf() === (new Date()).valueOf() ? 'true' : 'false');
  date.setDate(date.getDate() + days);
  date.setMonth(date.getMonth() + months);
  date.setFullYear(date.getFullYear()+ years);
  return  ((date.getMonth() + (isToday == 'true' ? 1 : 0) == 2) && this.pad1(date.getDate(), 2) == '29' ? '28' : this.pad1(date.getDate(), 2)) + '.' + this.pad1(date.getMonth() + (isToday == 'true' ? 1 : 0), 2) + '.' +  (date.getFullYear());
}
deltaDate2(days:number, months:number, years:number) {
  var date = new Date();
  let isToday = (date.valueOf() === (new Date()).valueOf() ? 'true' : 'false');
  date.setDate(date.getDate() + days);
  date.setMonth(date.getMonth() + months);
  date.setFullYear(date.getFullYear()+ years);
  return (date.getFullYear()) +'-'+ this.pad1(date.getMonth() + (isToday == 'true' ? 1 : 0), 2) +'-'+ ((date.getMonth() + (isToday == 'true' ? 1 : 0) == 2) && this.pad1(date.getDate(), 2) == '29' ? '28' : this.pad1(date.getDate(), 2)); 
}

/**
 * Возвращает сумму прописью
 */
number_to_string (num:any) {
  var def_translite = {
      null: 'ноль',
      a1: ['один','два','три','четыре','пять','шесть','семь','восемь','девять'],
      a2: ['одна','две','три','четыре','пять','шесть','семь','восемь','девять'],
      a10: ['десять','одиннадцать','двенадцать','тринадцать','четырнадцать','пятнадцать','шестнадцать','семнадцать','восемнадцать','девятнадцать'],
      a20: ['двадцать','тридцать','сорок','пятьдесят','шестьдесят','семьдесят','восемьдесят','девяносто'],
      a100: ['сто','двести','триста','четыреста','пятьсот','шестьсот','семьсот','восемьсот','девятьсот'],
      uc: ['тиын', 'тиын', 'тиын'],
      ur: ['тенге', 'тенге', 'тенге'],
      u3: ['тысяча', 'тысячи', 'тысяч'],
      u2: ['миллион', 'миллиона', 'миллионов'],
      u1: ['миллиард', 'миллиарда', 'миллиардов'],
  }
var i1, i2, i3, kop, out, rub, v, zeros, _ref, _ref1, _ref2, ax;

_ref = parseFloat(num).toFixed(2).split('.'), rub = _ref[0], kop = _ref[1];
var leading_zeros = 12 - rub.length;
if (leading_zeros < 0) {
  return false;
}

zeros = [];
while (leading_zeros--) {
  zeros.push('0');
}
rub = zeros.join('') + rub;
out = [];
if (rub > 0) {
  // Разбиваем число по три символа
  _ref1 = this.str_split(rub, 3);
  for (var i = -1; i < _ref1.length;i++) {
      v = _ref1[i];
      if (!(v > 0)) continue;
      _ref2 = this.str_split(v, 1), i1 = parseInt(_ref2[0]), i2 = parseInt(_ref2[1]), i3 = parseInt(_ref2[2]);
      out.push(def_translite.a100[i1-1]); // 1xx-9xx
      ax = (i+1 == 3) ? 'a2' : 'a1';
      if (i2 > 1) {
          out.push(def_translite.a20[i2-2] + (i3 > 0 ?  ' ' + def_translite[ax][i3-1] : '')); // 20-99
      } else {
          out.push(i2 > 0 ? def_translite.a10[i3] : def_translite[ax][i3-1]); // 10-19 | 1-9
      }
      
      if (_ref1.length > i+1){
          var name = def_translite['u'+(i+1)];
          out.push(this.morph(v,name));
      }
  }
} else {
  out.push(def_translite.null);
}
// Дописываем название "тенге"
out.push(this.morph(rub, def_translite.ur));
// Дописываем название "тиын"
out.push(kop + ' ' + this.morph(kop, def_translite.uc));

// Объединяем маcсив в строку, удаляем лишние пробелы и возвращаем результат
return out.join(' ').replace(RegExp(' {2,}', 'g'), ' ').trimLeft();
};

/**
 * Преобразует строку в массив
 */

str_split(string, length) {
  var chunks, len, pos;
  
  string = (string == null) ? "" : string;
  length =  (length == null) ? 1 : length;
  
  chunks = [];
  pos = 0;
  var len = string.length;
  while (pos < len) {
      chunks.push(string.slice(pos, pos += length));
  }
  
  return chunks;
};
/**
 * Склоняем словоформу
 */
morph(number, titles) {
  var cases = [2, 0, 1, 1, 1, 2];
  return titles[ (number>4 && number<20)? 2 : cases[Math.min(number, 5)] ];
};

pad1(num:any, size:any) {
  let s = num + "";
  while (s.length < size) s = "0" + s;
  return s;
}
private pad(n): string {
 if (n < 10) {
    return '0' + n;
}
  return n.toString();
}


}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
